import React, { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

/**
 * ThemeToggle - switches between "dark" (default luxury) and "natural" (cream parchment) themes.
 * Theme persists in localStorage and is applied via data-theme attribute on <html>.
 */
const ThemeToggle = ({ className = '' }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return 'dark';
    return localStorage.getItem('seatask-theme') || 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('seatask-theme', theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === 'dark' ? 'natural' : 'dark'));

  const isNatural = theme === 'natural';

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      title={isNatural ? 'Switch to dark theme' : 'Switch to natural theme'}
      aria-label="Toggle theme"
      className={`relative inline-flex items-center justify-center w-10 h-10 rounded-md border border-[var(--color-border)] hover:border-[var(--color-gold)] transition-all group ${className}`}
    >
      <Sun
        className={`w-4 h-4 absolute transition-all duration-500 ${
          isNatural ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-50'
        }`}
        strokeWidth={1.5}
        style={{ color: 'var(--color-gold)' }}
      />
      <Moon
        className={`w-4 h-4 absolute transition-all duration-500 ${
          isNatural ? 'opacity-0 rotate-90 scale-50' : 'opacity-100 rotate-0 scale-100'
        }`}
        strokeWidth={1.5}
        style={{ color: 'var(--color-gold)' }}
      />
    </button>
  );
};

export default ThemeToggle;
